import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { MillieAvatar } from "../components/MascotBubble";

const LINES = [
  "Setting the table for the Pattersons…",
  "Checking what Archie will actually eat…",
  "Keeping Tuesday and Thursday quick — swimming nights…",
  "Writing the week in Woolies language…",
  "Nearly there, legend…",
];

export default function Demo() {
  const navigate = useNavigate();
  const { setSession, selectHousehold, user } = useAuth();
  const [line, setLine] = useState(0);
  const started = useRef(false);

  useEffect(() => {
    const t = setInterval(() => setLine((l) => Math.min(l + 1, LINES.length - 1)), 6000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    if (started.current || user) return;
    started.current = true;
    (async () => {
      try {
        const { data } = await api.post("/demo/start");
        localStorage.setItem("sorted_token", data.token);
        selectHousehold(data.household_id);
        for (let i = 0; i < 30; i++) {
          const { data: plan } = await api.get(`/plan/${data.household_id}`).catch(() => ({ data: null }));
          if (plan?.days?.length) break;
          await new Promise((r) => setTimeout(r, 2500));
        }
        await setSession(data);
        navigate("/home", { replace: true });
      } catch {
        toast.error("Couldn't start the demo just now — give it another go");
        navigate("/", { replace: true });
      }
    })();
  }, [user, navigate, selectHousehold, setSession]);

  return (
    <div className="min-h-screen bg-[#FFF6F1] flex flex-col items-center justify-center px-8 text-center" data-testid="demo-loading">
      <MillieAvatar size={120} mood="cooking" entrance="pop" />
      <h1 className="mt-6 font-hand text-4xl text-sorted-ink">Millie's sorting a demo week</h1>
      <p className="mt-3 text-sm font-semibold text-sorted-slate max-w-xs min-h-[2.5rem]" data-testid="demo-loading-line">{LINES[line]}</p>
      <div className="mt-6 w-48 h-2 rounded-full bg-white overflow-hidden">
        <div className="h-full bg-sorted-rose rounded-full transition-[width] duration-[6000ms] ease-linear" style={{ width: `${20 + line * 20}%` }} />
      </div>
      <p className="mt-8 text-xs font-semibold text-sorted-slate/70">You'll get your own copy of a real family — swap meals, chat with Millie, scan the kitchen. It disappears after 24 hours.</p>
    </div>
  );
}
